import api from './api';

export const getMeals = (params) => api.get('/v1/meals', { params });
export const getMeal = (id) => api.get(`/v1/meals/${id}`);
export const createMeal = (data) => api.post('/v1/meals', data);
export const updateMeal = (id, data) => api.put(`/v1/meals/${id}`, data);
export const deleteMeal = (id) => api.delete(`/v1/meals/${id}`);
export const batchDeleteMeals = (ids) => api.post('/v1/meals/batch-delete', ids);
